import { Component, Inject } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { Router, RouterOutlet } from '@angular/router';

// @ts-ignore
import * as CryptoJS from 'crypto-js';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';
import { NgxSonnerToaster } from 'ngx-sonner';
import { slideInAnimation } from './shared/utils/animation';
import { UserDataList } from './core/models/auth.model';
import { environment } from 'src/environments/environment.dev';
import { LoginService } from './services/login/login.service';
import { FormControl } from '@angular/forms';
import { ToastService } from './services/toast/toast.service';
import { CartItemsComponent } from './modules/cart-items/cart-items.component';
import { BotComponent } from'./modules/bot/bot.component'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, ResponsiveHelperComponent, NgxSonnerToaster, CartItemsComponent, BotComponent],
  animations: [slideInAnimation]
})
export class AppComponent {
  title = 'Global House';
  env = environment;
  
  // private idle: Idle;
  // private keepalive: Keepalive;
  // private profileService: ProfileService;

  constructor(
    public themeService: ThemeService,
    private loginService : LoginService,
    public toastService: ToastService,
    // @Inject(Idle) idle: Idle,
    // @Inject(Keepalive) keepalive: Keepalive,
    // @Inject(ProfileService) profileService: ProfileService,
    private _router: Router
  ) {
    // this.idle = idle;
    // this.keepalive = keepalive;
    // this.profileService = profileService;
  }
  
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData;
  }

  public set_localstorage(p: UserDataList): void {
    const ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(p),
      this.env.symmetricKey
    ).toString();
    localStorage.setItem('sessionID', ciphertext);
  }
  
//   get_localstorage_user_name() {
//   try {
//     const data = localStorage.getItem('sessionID'); // Modifica por tu clave real
    
//     if (!data) {
//       this._router.navigate(['/login']); 
//       return null;
//     }
    
//     return JSON.parse(data);
//   } catch (error) {
//     console.warn('Datos corruptos en LocalStorage, redireccionando...');
//     localStorage.clear(); 
//     this._router.navigate(['/login']);
//     return null;
//   }
// }
  
  public startIdleDetect() {
    // this.idle.watch();
    this.startkeepAlive();
  }

  private startkeepAlive() {
    // this.keepalive.interval(15);
  }

  public login_validate(): boolean {
    return localStorage.getItem('sessionID') != null;
  }

  // public getPermissionsByIdUser() {
  //   this.profileService.getbyid(this.getUserId())
  //     .subscribe((response) => {
  //       this.validateSession(response);
  //       if (response.code == undefined) {
  //         // this.profilePermissionDtoProfile = response;
  //         // this.showViewProfile = true;
  //         //console.log(this.profilePermissionDtoProfile);
  //       }
  //     });
  // }
  
  validateSession(res: any): void {
    if (res.code !== undefined && (res.code == 400 || res.code == 408)) {
      // this.updateModal?.hide();
      this.remove_localstorage();
      this._router.navigateByUrl('/');
    }
  }
   public remove_localstorage(): void {
    localStorage.clear();
    // this.idle.stop();
    // this.logOutModal?.hide();
    // this.breakModal?.hide();
    this._router.navigateByUrl('/');
  }
  
  public getEventValue($event:any) :string {
    return $event.target.value;
  }

  logOut(): void {
    this.loginService.logOut().subscribe(
      (res) => {
      this.remove_localstorage();
      },
      (error) => {
        this.remove_localstorage();
      }
    );
  }

    public get_localstorage_user_name(): string | null {
    const bytes = CryptoJS.AES.decrypt(
      localStorage.getItem('sessionID') || '',
      this.env.symmetricKey
    );
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData.firstName + ' ' + decryptedData.lastName;
  }

  public formatDate(date: string): string {
    return (
      date.trim() === '' ? '' : date.split('-')[1] + '/' + date.split('-')[2] + '/' + date.split('-')[0]
    );
  }

  public formatDateSql(date: string): string {
    return (
      date.trim() === '' ? '' : date.split('/')[2] + '-' + date.split('/')[0] + '-' + date.split('/')[1]
    );
  }

  public normalizeString(text: string): string {
    if (text == null || text == 'undefined') {
      return '';
    } else {
      let returnText = text.toUpperCase();
      returnText =
        returnText.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      returnText = returnText.replace(/'/g, "''");
      return returnText.trim();
    }
  }
  
  public noWhitespaceValidator(control: FormControl) {
    return control.value?.trim() ? null : { whitespace: true };
}


  public noCharacterValidator(control: FormControl) {
    const pattern = /^[A-Za-zÀ-ÿ0-9\u00f1\u00d1\s]*$/g.test(control.value);
    const isValid = pattern;
    return isValid ? null : { patter: true };
  }

  public toUpperString(text: string): string {
    if (text == null || text == 'undefined') {
      return '';
    } else {
      return text.toUpperCase().trim().replace(/'/g, "''");
    }
  }
  public toLowerString(text: string): string {
    if (text == null || text == 'undefined') {
      return '';
    } else {
      return text.toLowerCase().trim().replace(/'/g, "''");
    }
  }
  showSuccess(): void {
    this.toastService.showToast('¡Operación exitosa!', 'success');
  }

  showError(): void {
    this.toastService.showToast('Error en la operación.', 'error');
  }

  showDeleteMessage(): void {
    this.toastService.showToast('Elemento eliminado correctamente.', 'error');
  }
  
  showUpdateMessage(): void {
    this.toastService.showToast('Elemento actualizado con éxito.', 'success');
  }
}
